<router-outlet></router-outlet>

<div id='parkingpass-errors' class='parkingpass-error-display'></div>